(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lurve-shipping-timeline"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lurve-dispatch-countdown')) {
    class LurveDispatchCountdown extends HTMLElement {
      connectedCallback() {
        this.update();
        clearInterval(this.interval);
        this.interval = setInterval(() => this.update(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      update() {
        // China Standard Time is UTC+8; UTC getters avoid the visitor's time zone.
        const chinaNow = new Date(Date.now() + 8 * 60 * 60 * 1000);
        const day = chinaNow.getUTCDay();
        const elapsed = chinaNow.getUTCHours() * 3600 + chinaNow.getUTCMinutes() * 60 + chinaNow.getUTCSeconds();
        const remaining = 17 * 3600 - elapsed;
        const message = this.querySelector('[data-dispatch-message]');
        const step = this.closest('.lurve-shipping-timeline')?.querySelector('[data-dispatch-step]');
        if (!message) return;

        if (day !== 0 && remaining > 0) {
          this.hidden = false;
          const hours = String(Math.floor(remaining / 3600)).padStart(2, '0');
          const minutes = String(Math.floor((remaining % 3600) / 60)).padStart(2, '0');
          const seconds = String(remaining % 60).padStart(2, '0');
          let time = message.querySelector('strong');
          if (!time) {
            time = document.createElement('strong');
            message.replaceChildren(document.createTextNode('Order within '), time, document.createTextNode(' for same-day dispatch'));
          }
          time.textContent = `${hours}h ${minutes}m ${seconds}s`;
          if (step) step.textContent = 'Same day';
        } else {
          this.hidden = true;
          const nextDay = day === 0 || day === 6 ? 'Monday' : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][day + 1];
          if (step) step.textContent = nextDay;
        }
      }
    }
    customElements.define('lurve-dispatch-countdown', LurveDispatchCountdown);
  }
  } catch(e) { console.error(e); }
})();

})();
